import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from '../utils';
function getDuplicatesQuery(duplicateRef) {
    return db.qnaNode
        .where('data.duplicateRef')
        .equals(duplicateRef)
        .and(node => [NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(node.type) &&
        !node.deleted);
}
export const getDuplicates = async (userID, question) => {
    const query = getDuplicatesQuery(question.data.duplicateRef);
    const questions = await query.toArray();
    return questions
        .filter(node => node._id !== question.id)
        .map(getSafeData);
};
